export const ADD_MESSAGE_ACTION = "MESSAGES::ADD_MESSAGE_ACTION";
export const DELETE_CHAT_MESSAGES_ACTION =
  "MESSAGES::DELETE_CHAT_MESSAGES_ACTION";
export const UPDATE_MESSAGES_ACTION = "MESSAGES::UPDATE_MESSAGES_ACTION";
